<mat-spinner *ngIf="loading"></mat-spinner>

<mat-horizontal-stepper
  class="wizard-background"
  linear="true"
  *ngIf="!loading"
  #stepper
>
  <mat-step>
    <div>
      <div class="card-container">
        <ng-template matStepLabel>Seleccione al paciente</ng-template>
        <app-budget-patient #patientComponent></app-budget-patient>
      </div>
    </div>
  </mat-step>
  <mat-step>
    <div>
      <div class="card-container">
        <ng-template matStepLabel>Presupuesto</ng-template>
        <app-budget-order-list></app-budget-order-list>
      </div>
    </div>
  </mat-step>
</mat-horizontal-stepper>
